/* GENERATED by maths-calculators/build.py, edit calcs.js not this file. */
MC_CONFIG["equivalent-fractions-calculator"] = { name: "Equivalent Fractions Calculator", fields: [{"id": "mode", "label": "What to do", "type": "select", "def": "list", "options": [["list", "List equivalent fractions"], ["missing", "Find the missing number"]]}, {"id": "n", "group": "F", "groupLabel": "The fraction", "slot": "num", "label": "Numerator (top)", "type": "number", "def": "2", "gt": 0, "int": true}, {"id": "d", "group": "F", "slot": "den", "label": "Denominator (bottom)", "type": "number", "def": "3", "gt": 0, "int": true}, {"id": "newd", "label": "The new bottom number", "type": "number", "def": "12", "gt": 0, "int": true, "showIf": {"mode": ["missing"]}}], example: {"mode": "list", "n": 2, "d": 3, "newd": 12}, run: (function (v, H) {
      if (v.mode === 'missing') {
        if (v.newd % v.d !== 0) {
          var f = v.newd / v.d;
          throw new Error('The new bottom must be a whole number of times bigger than ' + v.d + '. Try a multiple of ' + v.d + ', because ' + v.newd + ' ÷ ' + v.d + ' = ' + Math.round(f * 100) / 100 + ' is not whole.');
        }
        var k = v.newd / v.d;
        var top = v.n * k;
        return {
          answer: H.frTok(H.fmt(top), H.fmt(v.newd)),
          steps: [
            'Compare the bottoms to find the scale factor: ' + H.fmt(v.newd) + ' ÷ ' + H.fmt(v.d) + ' = ' + H.fmt(k),
            'Multiply the top by the SAME scale factor: ' + H.fmt(v.n) + ' × ' + H.fmt(k) + ' = ' + H.fmt(top),
            'So ' + H.frTok(H.fmt(v.n), H.fmt(v.d)) + ' = ' + H.frTok(H.fmt(top), H.fmt(v.newd))
          ],
          note: 'Whatever you do to the bottom you must do to the top, or the fraction changes value.'
        };
      }
      var g = H.gcd(v.n, v.d);
      var bn = v.n / g, bd = v.d / g;
      var list = [], i;
      for (i = 1; i <= 6; i++) list.push(H.frTok(H.fmt(bn * i), H.fmt(bd * i)));
      var steps = [];
      if (g > 1) steps.push('First reduce to the simplest form by dividing both parts by ' + H.fmt(g) + ': ' + H.frTok(H.fmt(v.n), H.fmt(v.d)) + ' = ' + H.frTok(H.fmt(bn), H.fmt(bd)));
      steps.push('Multiply top and bottom by 2, 3, 4 and so on. Each pair keeps the same value because you are multiplying by 1 in disguise');
      steps.push('The first six equivalent fractions are ' + list.join(', '));
      return {
        answer: list.join(', '), steps: steps,
        note: 'As a decimal each of these is ' + H.fmt(bn / bd) + ', which is why they are worth the same.'
      };
    }), preview: (function (v, H) {
      if (v.mode === 'missing') return H.frTok(v.n, v.d) + '  =  ' + H.frTok('?', v.newd);
      return 'Fractions equal to ' + H.frTok(v.n, v.d);
    }), widget: (function (v, H) {
      var n = Number(v.n), d = Number(v.d), nd = Number(v.newd);
      if (!isFinite(n) || !isFinite(d) || d <= 0 || n <= 0) return '';
      var mk = H.mkHtml;
      var ints = Number.isInteger(n) && Number.isInteger(d);
      var rows = '', barLine, top;
      if (v.mode === 'missing') {
        if (!isFinite(nd) || nd <= 0 || !Number.isInteger(nd) || nd % d !== 0) return '';
        top = n * (nd / d);
        barLine = '<p class="mc-rule-line"><span class="mc-rule-f">The bottom went ×' + H.fmt(nd / d) + ', so the top does too: ' + mk(H.frTok(H.fmt(n), H.fmt(d))) + ' = <b>' + mk(H.frTok(H.fmt(top), H.fmt(nd))) + '</b></span><span class="mc-rule-why">Whatever multiplies the bottom must multiply the top.</span></p>';
        if (!(ints && n < d && nd <= 24)) return barLine;
        rows = '<text class="mc-fb-sub" x="60" y="12">Your fraction</text>' +
          H.fbBar(60, 20, 300, d, n, 0) + H.fbFrac(388, 36, H.fmt(n), H.fmt(d)) +
          '<text class="mc-fb-sub" x="60" y="92">Cut into ' + H.fmt(nd) + 'ths instead: the shaded amount stays the same</text>' +
          H.fbBar(60, 100, 300, nd, top, 0) + H.fbFrac(388, 116, H.fmt(top), H.fmt(nd));
        return '<p class="mc-tri-hint">Same amount, different size pieces: that is all an equivalent fraction is.</p>' +
          '<svg class="mc-tri" viewBox="0 0 600 146" style="max-width:640px" role="group" aria-label="Bar model of the equivalent fraction">' + rows + '</svg>' + barLine;
      }
      var g = H.gcd(n, d);
      var bn = n / g, bd = d / g;
      barLine = '<p class="mc-rule-line"><span class="mc-rule-f">Multiply top and bottom together: ' + mk(H.frTok(H.fmt(bn), H.fmt(bd))) + ' = ' + mk(H.frTok(H.fmt(bn * 2), H.fmt(bd * 2))) + ' = ' + mk(H.frTok(H.fmt(bn * 3), H.fmt(bd * 3))) + ' = ...</span><span class="mc-rule-why">Every one is the same amount, cut into different size pieces.</span></p>';
      if (!(ints && n < d && d <= 12)) return barLine;
      var y = 0, k;
      for (k = 1; k <= 3; k++) {
        rows += '<text class="mc-fb-sub" x="60" y="' + (y + 12) + '">' + (k === 1 ? 'Your fraction' : 'Cut each piece into ' + H.fmt(k) + '') + '</text>' +
          H.fbBar(60, y + 20, 300, d * k, n * k, 0) + H.fbFrac(388, y + 36, H.fmt(n * k), H.fmt(d * k));
        y += 78;
      }
      return '<p class="mc-tri-hint">Every bar shades the same amount: equivalent fractions are the same value cut into different size pieces.</p>' +
        '<svg class="mc-tri" viewBox="0 0 600 ' + (y - 12) + '" style="max-width:640px" role="group" aria-label="Bar models of equivalent fractions">' + rows + '</svg>' + barLine;
    }) };
MC_CONFIG["factors-of-a-number-calculator"] = { name: "Factors of a Number Calculator", fields: [{"id": "n", "label": "Number", "type": "number", "def": "36", "gt": 0, "int": true, "max": 1000000}], example: {"n": 36}, run: (function (v, H) {
      var pairs = [], factors = [], i;
      for (i = 1; i * i <= v.n; i++) {
        if (v.n % i === 0) {
          var j = v.n / i;
          pairs.push(i === j ? H.fmt(i) + ' × ' + H.fmt(j) : H.fmt(i) + ' × ' + H.fmt(j));
          factors.push(i);
          if (i !== j) factors.push(j);
        }
      }
      factors.sort(function (x, y) { return x - y; });
      var steps = [
        'Work upwards from 1, and every factor you find hands you its partner: ' + pairs.join(', '),
        'Stop once the pairs meet in the middle, at the square root of ' + H.fmt(v.n),
        'Put them in order: ' + factors.map(H.fmt).join(', ') + ', which is ' + H.fmt(factors.length) + ' ' + H.plural(factors.length, 'factor', 'factors')
      ];
      var isSquare = Math.round(Math.sqrt(v.n)) * Math.round(Math.sqrt(v.n)) === v.n;
      var note;
      if (v.n === 1) note = '1 is the only number with exactly one factor. It is not prime.';
      else if (factors.length === 2) note = H.fmt(v.n) + ' has exactly two factors, 1 and itself, so it is a PRIME number.';
      else if (isSquare) note = H.fmt(v.n) + ' is a square number, so it has an odd number of factors: the middle pair is ' + H.fmt(Math.sqrt(v.n)) + ' × ' + H.fmt(Math.sqrt(v.n)) + ', which only counts once.';
      else note = 'Factors always come in pairs, which is why most numbers have an even number of them.';
      return { answer: factors.map(H.fmt).join(', '), steps: steps, note: note };
    }), preview: (function (v, H) { return 'All the factors of ' + v.n; }) };
MC_CONFIG["roman-numerals-calculator"] = { name: "Roman Numerals Converter", fields: [{"id": "mode", "label": "Convert", "type": "select", "def": "toroman", "options": [["toroman", "Number to Roman numerals"], ["tonumber", "Roman numerals to number"]]}, {"id": "num", "label": "The number (1 to 3999)", "type": "number", "def": "2024", "gt": 0, "max": 3999, "int": true, "showIf": {"mode": ["toroman"]}}, {"id": "rom", "label": "The Roman numerals", "type": "text", "def": "MMXXIV", "showIf": {"mode": ["tonumber"]}}], example: {"mode": "toroman", "num": 2024, "rom": "MMXXIV"}, run: (function (v, H) {
      var VALS = [1000, 900, 500, 400, 100, 90, 50, 40, 10, 9, 5, 4, 1];
      var LETS = ['M', 'CM', 'D', 'CD', 'C', 'XC', 'L', 'XL', 'X', 'IX', 'V', 'IV', 'I'];
      var steps = [], i;
      if (v.mode === 'toroman') {
        var left = v.num, out = '';
        for (i = 0; i < VALS.length; i++) {
          while (left >= VALS[i]) {
            out += LETS[i];
            left -= VALS[i];
            steps.push('Take ' + H.fmt(VALS[i]) + ' (' + LETS[i] + ')' + (LETS[i].length === 2 ? ', a subtraction pair meaning ' + LETS[i].charAt(1) + ' minus ' + LETS[i].charAt(0) : '') + ', leaving ' + H.fmt(left));
            if (steps.length > 20) break;
          }
        }
        steps.push('Put the letters together in order: ' + H.fmt(v.num) + ' = ' + out);
        return { answer: out, steps: steps, note: 'Always take the biggest value you can each time, which keeps the numeral as short as possible.' };
      }
      var s = String(v.rom).toUpperCase().replace(/\s/g, '');
      if (!s) throw new Error('Type some Roman numerals, like MMXXIV.');
      if (!/^[MDCLXVI]+$/.test(s)) throw new Error('Roman numerals only use the letters M, D, C, L, X, V and I.');
      var total = 0, pos = 0;
      while (pos < s.length) {
        var matched = false;
        for (i = 0; i < VALS.length; i++) {
          if (s.substr(pos, LETS[i].length) === LETS[i]) {
            total += VALS[i];
            steps.push(LETS[i] + ' is ' + H.fmt(VALS[i]) + (LETS[i].length === 2 ? ' (a smaller letter in front means subtract)' : '') + ', running total ' + H.fmt(total));
            pos += LETS[i].length;
            matched = true;
            break;
          }
        }
        if (!matched) throw new Error('"' + s + '" is not a valid Roman numeral. Check the order of the letters.');
        if (steps.length > 20) break;
      }
      steps.push('Add them all up: ' + s + ' = ' + H.fmt(total));
      return { answer: H.fmt(total), steps: steps };
    }), preview: (function (v, H) {
      return v.mode === 'toroman' ? v.num + ' in Roman numerals' : String(v.rom).toUpperCase() + ' as a number';
    }) };
MC_CONFIG["completing-the-square-calculator"] = { name: "Completing the Square Calculator", fields: [{"id": "a", "group": "Q", "groupLabel": "The quadratic", "label": "a, the number with x\u00b2 (often 1)", "type": "number", "def": "1", "int": true, "min": 1, "max": 20}, {"id": "b", "group": "Q", "label": "b, the number with x", "type": "number", "def": "6"}, {"id": "c", "group": "Q", "label": "c, the number on its own", "type": "number", "def": "11"}], example: {"a": 1, "b": 6, "c": 11}, run: (function (v, H) {
      var steps = [];
      var expr = (v.a === 1 ? '' : H.fmt(v.a)) + 'x²'
        + (v.b === 0 ? '' : (v.b < 0 ? ' − ' : ' + ') + (Math.abs(v.b) === 1 ? '' : H.fmt(Math.abs(v.b))) + 'x')
        + (v.c === 0 ? '' : (v.c < 0 ? ' − ' : ' + ') + H.fmt(Math.abs(v.c)));
      var inner, rest;
      if (v.a !== 1) {
        steps.push('Take the ' + H.fmt(v.a) + ' out of the x parts first: ' + H.fmt(v.a) + '(x² ' + (v.b < 0 ? '− ' : '+ ') + H.fmt(Math.abs(v.b / v.a)) + 'x)' + (v.c === 0 ? '' : (v.c < 0 ? ' − ' : ' + ') + H.fmt(Math.abs(v.c))));
      }
      var half = v.b / (2 * v.a);
      steps.push('Halve the number with x inside the bracket: ' + H.fmt(v.b / v.a) + ' ÷ 2 = ' + H.fmt(half) + ', so the bracket is (x ' + (half < 0 ? '− ' : '+ ') + H.fmt(Math.abs(half)) + ')');
      steps.push('Squaring that bracket adds an extra ' + H.fmt(half * half) + ', so subtract it again to keep the value the same');
      rest = v.c - v.a * half * half;
      var brk = '(x ' + (half < 0 ? '− ' : '+ ') + H.fmt(Math.abs(half)) + ')²';
      var ansStr = (v.a === 1 ? '' : H.fmt(v.a)) + brk + (rest === 0 ? '' : (rest < 0 ? ' − ' : ' + ') + H.fmt(Math.abs(rest)));
      steps.push('Tidy the numbers outside the bracket: ' + H.fmt(v.c) + ' − ' + (v.a === 1 ? '' : H.fmt(v.a) + ' × ') + H.fmt(half * half) + ' = ' + H.fmt(rest) + ', so ' + expr + ' = ' + ansStr);
      var tx = -half, ty = rest;
      return {
        answer: ansStr, steps: steps,
        note: 'The turning point of the graph is at (' + H.fmt(tx) + ', ' + H.fmt(ty) + '), and because a square is never negative the smallest value the expression can reach is ' + H.fmt(ty) + '.'
      };
    }), preview: (function (v, H) {
      var aa = v.a === '?' ? '?' : (Number(v.a) === 1 ? '' : v.a);
      var bb = v.b === '?' ? ' + ?x' : Number(v.b) === 0 ? '' : (Number(v.b) < 0 ? ' − ' + Math.abs(v.b) : ' + ' + Math.abs(v.b)) + 'x';
      var cc = v.c === '?' ? ' + ?' : Number(v.c) === 0 ? '' : Number(v.c) < 0 ? ' − ' + Math.abs(v.c) : ' + ' + v.c;
      return aa + 'x²' + bb + cc;
    }) };
MC_CONFIG["substitution-calculator"] = { name: "Substitution Calculator", fields: [{"id": "shape", "label": "Expression", "type": "select", "def": "quad", "options": [["lin", "ax + b"], ["quad", "ax\u00b2 + bx + c"], ["two", "ax + by"]]}, {"id": "a", "label": "a", "type": "number", "def": "2"}, {"id": "b", "label": "b", "type": "number", "def": "-3"}, {"id": "c", "label": "c", "type": "number", "def": "4", "showIf": {"shape": ["quad"]}}, {"id": "x", "label": "The value of x", "type": "number", "def": "-5"}, {"id": "y", "label": "The value of y", "type": "number", "def": "2", "showIf": {"shape": ["two"]}}], example: {"shape": "quad", "a": 2, "b": -3, "c": 4, "x": -5, "y": 2}, run: (function (v, H) {
      function br(n) { return n < 0 ? '(−' + H.fmt(Math.abs(n)) + ')' : H.fmt(n); }
      function neat(n) { return n < 0 ? '−' + H.fmt(Math.abs(n)) : H.fmt(n); }
      var steps = [], ans;
      if (v.shape === 'lin') {
        steps.push('Swap the letter for its value, keeping a negative inside brackets: ' + H.fmt(v.a) + ' × ' + br(v.x) + (v.b < 0 ? ' − ' + H.fmt(Math.abs(v.b)) : ' + ' + H.fmt(v.b)));
        steps.push('Multiply first: ' + H.fmt(v.a) + ' × ' + br(v.x) + ' = ' + neat(v.a * v.x));
        ans = v.a * v.x + v.b;
        steps.push('Then add or subtract: ' + neat(v.a * v.x) + (v.b < 0 ? ' − ' + H.fmt(Math.abs(v.b)) : ' + ' + H.fmt(v.b)) + ' = ' + neat(ans));
      } else if (v.shape === 'quad') {
        var sq = v.x * v.x;
        steps.push('Swap x for its value, keeping the negative inside brackets: ' + H.fmt(v.a) + ' × ' + br(v.x) + '² ' + (v.b < 0 ? '− ' + H.fmt(Math.abs(v.b)) : '+ ' + H.fmt(v.b)) + ' × ' + br(v.x) + (v.c < 0 ? ' − ' + H.fmt(Math.abs(v.c)) : ' + ' + H.fmt(v.c)));
        steps.push('Squaring comes before multiplying: ' + br(v.x) + '² = ' + H.fmt(sq) + (v.x < 0 ? ', positive because a negative times a negative is positive' : ''));
        steps.push('Now the multiplications: ' + H.fmt(v.a) + ' × ' + H.fmt(sq) + ' = ' + neat(v.a * sq) + ', and ' + H.fmt(v.b) + ' × ' + br(v.x) + ' = ' + neat(v.b * v.x));
        ans = v.a * sq + v.b * v.x + v.c;
        steps.push('Add it all up: ' + neat(v.a * sq) + ' + ' + br(v.b * v.x) + ' + ' + br(v.c) + ' = ' + neat(ans));
      } else {
        steps.push('Swap both letters for their values: ' + H.fmt(v.a) + ' × ' + br(v.x) + (v.b < 0 ? ' − ' + H.fmt(Math.abs(v.b)) : ' + ' + H.fmt(v.b)) + ' × ' + br(v.y));
        steps.push('Do the multiplications first: ' + H.fmt(v.a) + ' × ' + br(v.x) + ' = ' + neat(v.a * v.x) + ', and ' + H.fmt(v.b) + ' × ' + br(v.y) + ' = ' + neat(v.b * v.y));
        ans = v.a * v.x + v.b * v.y;
        steps.push('Add the two parts: ' + neat(v.a * v.x) + ' + ' + br(v.b * v.y) + ' = ' + neat(ans));
      }
      return {
        answer: neat(ans), steps: steps,
        note: 'Writing negatives in brackets is the whole trick: without them −5² looks like −25 when it should be 25.'
      };
    }), preview: (function (v, H) {
      function t(k, s, first) {
        if (k === '?') return (first ? '' : ' + ') + '?' + s;
        var n = Number(k);
        if (n === 0 && s) return '';
        var mag = Math.abs(n) === 1 && s ? '' : String(Math.abs(n));
        if (first) return (n < 0 ? '−' : '') + mag + s;
        return (n < 0 ? ' − ' : ' + ') + mag + s;
      }
      var e;
      if (v.shape === 'lin') e = t(v.a, 'x', true) + t(v.b, '');
      else if (v.shape === 'quad') e = t(v.a, 'x²', true) + t(v.b, 'x') + t(v.c, '');
      else e = t(v.a, 'x', true) + t(v.b, 'y');
      var vals = 'x = ' + v.x + (v.shape === 'two' ? ', y = ' + v.y : '');
      return e + '   when   ' + vals;
    }) };
MC_CONFIG["changing-the-subject-calculator"] = { name: "Changing the Subject Calculator", fields: [{"id": "shape", "label": "The formula", "type": "select", "def": "linear", "options": [["linear", "y = ax + b"], ["bracket", "y = a(x + b)"], ["square", "y = ax\u00b2"], ["frac", "y = a \u00f7 x"], ["root", "y = \u221a(x + a)"]]}, {"id": "a", "label": "The value of a", "type": "number", "def": "2"}, {"id": "b", "label": "The value of b", "type": "number", "def": "5", "showIf": {"shape": ["linear", "bracket"]}}], example: {"shape": "linear", "a": 2, "b": 5}, run: (function (v, H) {
      function sgn(n) { return n < 0 ? ' + ' + H.fmt(Math.abs(n)) : ' − ' + H.fmt(n); }
      var steps = [], ans, start;
      if (v.shape === 'linear') {
        if (v.a === 0) throw new Error('With a = 0 there is no x left in the formula. Use a value other than 0.');
        start = 'y = ' + H.fmt(v.a) + 'x' + (v.b < 0 ? ' − ' + H.fmt(Math.abs(v.b)) : ' + ' + H.fmt(v.b));
        steps.push('x has been multiplied by ' + H.fmt(v.a) + ' and then ' + (v.b < 0 ? H.fmt(Math.abs(v.b)) + ' taken off' : H.fmt(v.b) + ' added') + '. Undo them in reverse');
        steps.push('First undo the ' + (v.b < 0 ? 'subtraction, by adding ' : 'addition, by subtracting ') + H.fmt(Math.abs(v.b)) + ' from both sides: y' + sgn(v.b) + ' = ' + H.fmt(v.a) + 'x');
        steps.push('Then undo the multiply, by dividing both sides by ' + H.fmt(v.a) + ': x = (y' + sgn(v.b) + ') ÷ ' + H.fmt(v.a));
        ans = 'x = (y' + sgn(v.b) + ') ÷ ' + H.fmt(v.a);
      } else if (v.shape === 'bracket') {
        if (v.a === 0) throw new Error('With a = 0 the whole right side is 0. Use a value other than 0.');
        start = 'y = ' + H.fmt(v.a) + '(x' + (v.b < 0 ? ' − ' + H.fmt(Math.abs(v.b)) : ' + ' + H.fmt(v.b)) + ')';
        steps.push('The bracket has been multiplied by ' + H.fmt(v.a) + ', so undo that first');
        steps.push('Divide both sides by ' + H.fmt(v.a) + ': y ÷ ' + H.fmt(v.a) + ' = x' + (v.b < 0 ? ' − ' + H.fmt(Math.abs(v.b)) : ' + ' + H.fmt(v.b)));
        steps.push('Now undo the ' + (v.b < 0 ? 'subtraction by adding ' : 'addition by subtracting ') + H.fmt(Math.abs(v.b)) + ': x = y ÷ ' + H.fmt(v.a) + sgn(v.b));
        ans = 'x = y ÷ ' + H.fmt(v.a) + sgn(v.b);
      } else if (v.shape === 'square') {
        if (v.a === 0) throw new Error('With a = 0 there is no x left in the formula. Use a value other than 0.');
        start = 'y = ' + H.fmt(v.a) + 'x²';
        steps.push('x has been squared and then multiplied by ' + H.fmt(v.a) + '. Undo the multiply first');
        steps.push('Divide both sides by ' + H.fmt(v.a) + ': y ÷ ' + H.fmt(v.a) + ' = x²');
        steps.push('Then undo the square by taking the square root of both sides: x = ±√(y ÷ ' + H.fmt(v.a) + ')');
        ans = 'x = ±√(y ÷ ' + H.fmt(v.a) + ')';
      } else if (v.shape === 'frac') {
        if (v.a === 0) throw new Error('With a = 0 the top of the fraction is 0. Use a value other than 0.');
        start = 'y = ' + H.fmt(v.a) + ' ÷ x';
        steps.push('x is underneath, so multiply both sides by x to lift it up: xy = ' + H.fmt(v.a));
        steps.push('Now x is multiplied by y, so divide both sides by y: x = ' + H.fmt(v.a) + ' ÷ y');
        ans = 'x = ' + H.fmt(v.a) + ' ÷ y';
      } else {
        start = 'y = √(x' + (v.a < 0 ? ' − ' + H.fmt(Math.abs(v.a)) : ' + ' + H.fmt(v.a)) + ')';
        steps.push('The bracket is inside a square root, so square both sides to remove it: y² = x' + (v.a < 0 ? ' − ' + H.fmt(Math.abs(v.a)) : ' + ' + H.fmt(v.a)));
        steps.push('Then undo the ' + (v.a < 0 ? 'subtraction by adding ' : 'addition by subtracting ') + H.fmt(Math.abs(v.a)) + ': x = y²' + sgn(v.a));
        ans = 'x = y²' + sgn(v.a);
      }
      return {
        answer: ans, steps: steps,
        note: 'Rearranging is the same skill as solving an equation, except the answer is a formula instead of a number. Start with ' + start + ' and undo the operations in reverse order.'
      };
    }), preview: (function (v, H) {
      var s = {
        linear: 'y = ' + v.a + 'x + ' + v.b,
        bracket: 'y = ' + v.a + '(x + ' + v.b + ')',
        square: 'y = ' + v.a + 'x²',
        frac: 'y = ' + v.a + ' ÷ x',
        root: 'y = √(x + ' + v.a + ')'
      }[v.shape];
      return 'Make x the subject of   ' + s;
    }) };
MC_CONFIG["simplifying-expressions-calculator"] = { name: "Simplifying Expressions Calculator", fields: [{"id": "x1", "group": "G1", "groupLabel": "First part", "label": "First group: number of x", "type": "number", "def": "3"}, {"id": "y1", "group": "G1", "label": "First group: number of y", "type": "number", "def": "2"}, {"id": "c1", "group": "G1", "label": "First group: plain number", "type": "number", "def": "5"}, {"id": "x2", "group": "G2", "groupLabel": "Second part", "label": "Second group: number of x", "type": "number", "def": "4"}, {"id": "y2", "group": "G2", "label": "Second group: number of y", "type": "number", "def": "-1"}, {"id": "c2", "group": "G2", "label": "Second group: plain number", "type": "number", "def": "-2"}], example: {"x1": 3, "y1": 2, "c1": 5, "x2": 4, "y2": -1, "c2": -2}, run: (function (v, H) {
      function t(n, s, first) {
        if (n === 0) return '';
        var mag = Math.abs(n) === 1 && s ? '' : H.fmt(Math.abs(n));
        if (first) return (n < 0 ? '−' : '') + mag + s;
        return (n < 0 ? ' − ' : ' + ') + mag + s;
      }
      function build(list) {
        var out = '', first = true;
        for (var i = 0; i < list.length; i++) {
          var piece = t(list[i][0], list[i][1], first);
          if (piece) { out += piece; first = false; }
        }
        return out || '0';
      }
      var xs = v.x1 + v.x2, ys = v.y1 + v.y2, cs = v.c1 + v.c2;
      var steps = [
        'Gather the x terms: ' + t(v.x1, 'x', true) + ' and ' + t(v.x2, 'x', true) + ' give ' + (xs === 0 ? '0, so the x terms cancel out' : t(xs, 'x', true)),
        'Gather the y terms: ' + t(v.y1, 'y', true) + ' and ' + t(v.y2, 'y', true) + ' give ' + (ys === 0 ? '0, so the y terms cancel out' : t(ys, 'y', true)),
        'Gather the plain numbers: ' + H.fmt(v.c1) + ' and ' + H.fmt(v.c2) + ' give ' + H.fmt(cs)
      ];
      var ans = build([[xs, 'x'], [ys, 'y'], [cs, '']]);
      steps.push('Write the groups together, letters first: ' + ans);
      return {
        answer: ans, steps: steps,
        note: 'x and y are different things, so they never combine. 3x + 2y stays as it is, however tempting 5xy looks.'
      };
    }), preview: (function (v, H) {
      function t(k, s, first) {
        if (k === '?') return (first ? '' : ' + ') + '?' + s;
        var n = Number(k);
        if (n === 0) return '';
        var mag = Math.abs(n) === 1 && s ? '' : String(Math.abs(n));
        if (first) return (n < 0 ? '−' : '') + mag + s;
        return (n < 0 ? ' − ' : ' + ') + mag + s;
      }
      var parts = [[v.x1, 'x'], [v.y1, 'y'], [v.c1, ''], [v.x2, 'x'], [v.y2, 'y'], [v.c2, '']];
      var out = '', first = true;
      for (var i = 0; i < parts.length; i++) {
        var piece = t(parts[i][0], parts[i][1], first);
        if (piece) { out += piece; first = false; }
      }
      return out || '0';
    }) };
MC_CONFIG["parallel-and-perpendicular-lines-calculator"] = { name: "Parallel and Perpendicular Lines Calculator", fields: [{"id": "m", "label": "Gradient of the first line (m)", "type": "number", "def": "2"}, {"id": "c", "label": "Its y intercept (c)", "type": "number", "def": "1"}, {"id": "rel", "label": "The new line is", "type": "select", "def": "perp", "options": [["par", "Parallel to it"], ["perp", "Perpendicular to it"]]}, {"id": "px", "label": "It passes through x =", "type": "number", "def": "4"}, {"id": "py", "label": "and y =", "type": "number", "def": "3"}], example: {"m": 2, "c": 1, "rel": "perp", "px": 4, "py": 3}, run: (function (v, H) {
      if (v.m === 0 && v.rel === 'perp') throw new Error('A flat line has gradient 0, so the perpendicular is vertical and cannot be written as y = mx + c. Its equation is simply x = ' + v.px + '.');
      var steps = [];
      var nm;
      if (v.rel === 'par') {
        nm = v.m;
        steps.push('Parallel lines have the SAME gradient, so the new gradient is also ' + H.fmt(v.m));
      } else {
        nm = -1 / v.m;
        steps.push('Perpendicular gradients multiply to −1, so flip ' + H.fmt(v.m) + ' upside down and change the sign: −1 ÷ ' + H.fmt(v.m) + ' = ' + H.fmt(nm));
      }
      var nc = v.py - nm * v.px;
      steps.push('Put the point (' + H.fmt(v.px) + ', ' + H.fmt(v.py) + ') into y = ' + H.fmt(nm) + 'x + c: ' + H.fmt(v.py) + ' = ' + H.fmt(nm) + ' × ' + H.fmt(v.px) + ' + c');
      steps.push('So c = ' + H.fmt(v.py) + ' − ' + H.fmt(nm * v.px) + ' = ' + H.fmt(nc));
      var mTerm = nm === 1 ? 'x' : nm === -1 ? '−x' : H.fmt(nm) + 'x';
      var eq = nm === 0 ? 'y = ' + H.fmt(nc) : 'y = ' + mTerm + (nc === 0 ? '' : (nc > 0 ? ' + ' + H.fmt(nc) : ' − ' + H.fmt(-nc)));
      steps.push('The new line is ' + eq);
      return {
        answer: eq, steps: steps,
        note: v.rel === 'perp'
          ? 'Check: ' + H.fmt(v.m) + ' × ' + H.fmt(nm) + ' = ' + H.fmt(v.m * nm) + ', and perpendicular gradients always multiply to −1.'
          : 'Parallel lines never meet, which is exactly why their gradients must match.'
      };
    }), preview: (function (v, H) {
      var mm = v.m === '?' ? '?' : (Number(v.m) === 1 ? '' : Number(v.m) === -1 ? '−' : v.m);
      var cc = v.c === '?' ? ' + ?' : Number(v.c) === 0 ? '' : Number(v.c) < 0 ? ' − ' + Math.abs(v.c) : ' + ' + v.c;
      return (v.rel === 'par' ? 'Parallel' : 'Perpendicular') + ' to y = ' + mm + 'x' + cc + ', through (' + v.px + ', ' + v.py + ')';
    }) };
MC_CONFIG["geometric-sequences-calculator"] = { name: "Geometric Sequences Calculator", fields: [{"id": "mode", "label": "What you know", "type": "select", "def": "ratio", "options": [["ratio", "First term and ratio"], ["terms", "The first two terms"]]}, {"id": "a", "label": "First term", "type": "number", "def": "3"}, {"id": "r", "label": "Common ratio (what it multiplies by)", "type": "number", "def": "2", "showIf": {"mode": ["ratio"]}}, {"id": "second", "label": "Second term", "type": "number", "def": "6", "showIf": {"mode": ["terms"]}}, {"id": "n", "label": "Which term do you want?", "type": "number", "def": "7", "gt": 0, "int": true, "max": 60}], example: {"mode": "ratio", "a": 3, "r": 2, "second": 6, "n": 7}, run: (function (v, H) {
      if (v.a === 0) throw new Error('A geometric sequence cannot start at 0, because multiplying would keep it at 0 for ever.');
      var steps = [], r;
      if (v.mode === 'terms') {
        r = v.second / v.a;
        steps.push('Find the common ratio by dividing the second term by the first: ' + H.fmt(v.second) + ' ÷ ' + H.fmt(v.a) + ' = ' + H.fmt(r));
      } else {
        r = v.r;
        steps.push('The sequence starts at ' + H.fmt(v.a) + ' and multiplies by ' + H.fmt(r) + ' each time');
      }
      if (r === 0) throw new Error('A ratio of 0 collapses the sequence to zeros. Use a ratio that is not 0.');
      var first = [], val = v.a, i;
      for (i = 0; i < Math.min(5, v.n); i++) { first.push(H.fmt(val)); val *= r; }
      steps.push('Writing the terms out: ' + first.join(', ') + (v.n > 5 ? ', ...' : ''));
      var rule = H.fmt(v.a) + ' × ' + H.fmt(r) + 'ⁿ⁻¹';
      steps.push('The nth term rule multiplies the first term by the ratio one time fewer than n: ' + rule);
      var nth = v.a * Math.pow(r, v.n - 1);
      if (!isFinite(nth) || Math.abs(nth) > 1e15) throw new Error('That term is too big to write out. Try a smaller term number or ratio.');
      steps.push('For term ' + H.fmt(v.n) + ': ' + H.fmt(v.a) + ' × ' + H.fmt(r) + H.sup(v.n - 1) + ' = ' + H.fmt(nth));
      return {
        answer: 'Term ' + H.fmt(v.n) + ' is ' + H.fmt(nth),
        steps: steps,
        note: 'The rule is ' + rule + '. The power is n − 1 because the first term has not been multiplied yet.'
      };
    }), preview: (function (v, H) {
      if (v.mode === 'terms') return 'Starts ' + v.a + ', ' + v.second + ', ...   find term ' + v.n;
      return 'First term ' + v.a + ', multiply by ' + v.r + ' each time. Find term ' + v.n;
    }) };
MC_CONFIG["estimated-mean-calculator"] = { name: "Estimated Mean Calculator", fields: [{"id": "lows", "label": "Lower bound of each class", "type": "text", "def": "0, 10, 20, 30", "hint": "Where each group starts, separated by commas."}, {"id": "highs", "label": "Upper bound of each class", "type": "text", "def": "10, 20, 30, 40", "hint": "Where each group ends."}, {"id": "fs", "label": "Frequency of each class", "type": "text", "def": "3, 7, 6, 4", "hint": "How many pieces of data fall in each group."}], example: {"lows": "0, 10, 20, 30", "highs": "10, 20, 30, 40", "fs": "3, 7, 6, 4"}, run: (function (v, H) {
      function parse(s, name) {
        var out = String(s).trim().split(/[\s,]+/).filter(function (t) { return t !== ''; }).map(Number);
        for (var i = 0; i < out.length; i++) {
          if (!isFinite(out[i])) throw new Error('The ' + name + ' list has something that is not a number.');
        }
        return out;
      }
      var lows = parse(v.lows, 'lower bound'), highs = parse(v.highs, 'upper bound'), fs = parse(v.fs, 'frequency');
      if (lows.length !== highs.length || lows.length !== fs.length) {
        throw new Error('All three lists must be the same length: ' + lows.length + ' lower bounds, ' + highs.length + ' upper bounds and ' + fs.length + ' frequencies.');
      }
      if (lows.length < 2) throw new Error('Give at least two class intervals.');
      if (lows.length > 12) throw new Error('Twelve classes is plenty.');
      var mids = [], fx = [], sumF = 0, sumFX = 0, i;
      for (i = 0; i < lows.length; i++) {
        if (highs[i] <= lows[i]) throw new Error('Class ' + (i + 1) + ' ends at ' + highs[i] + ', which is not above its start of ' + lows[i] + '.');
        if (fs[i] < 0 || !Number.isInteger(fs[i])) throw new Error('Frequencies must be whole numbers, 0 or more.');
        var m = (lows[i] + highs[i]) / 2;
        mids.push(m);
        fx.push(m * fs[i]);
        sumF += fs[i];
        sumFX += m * fs[i];
      }
      if (sumF === 0) throw new Error('Every frequency is 0, so there is no data to average.');
      var midText = [], fxText = [];
      for (i = 0; i < mids.length; i++) {
        midText.push('(' + H.fmt(lows[i]) + '+' + H.fmt(highs[i]) + ')÷2=' + H.fmt(mids[i]));
        fxText.push(H.fmt(mids[i]) + '×' + H.fmt(fs[i]) + '=' + H.fmt(fx[i]));
      }
      var mean = sumFX / sumF;
      return {
        answer: 'Estimated mean = ' + H.fmt(mean),
        steps: [
          'Find the midpoint of each class, because the actual values are unknown: ' + midText.join(', '),
          'Multiply each midpoint by its frequency to build the fx column: ' + fxText.join(', '),
          'Add the columns: Σf = ' + H.fmt(sumF) + ' pieces of data and Σfx = ' + H.fmt(sumFX),
          'Divide: Σfx ÷ Σf = ' + H.fmt(sumFX) + ' ÷ ' + H.fmt(sumF) + ' = ' + H.fmt(mean)
        ],
        note: 'It is an estimate because every value in a class is treated as sitting exactly at the midpoint, which is rarely true.'
      };
    }), preview: (function (v, H) {
      var l = String(v.lows).split(/[\s,]+/).filter(Boolean);
      var h = String(v.highs).split(/[\s,]+/).filter(Boolean);
      var f = String(v.fs).split(/[\s,]+/).filter(Boolean);
      var out = [];
      for (var i = 0; i < Math.max(l.length, h.length); i++) {
        out.push((l[i] || '?') + ' to ' + (h[i] || '?') + ': ' + (f[i] || '?'));
      }
      return out.join(',  ');
    }) };
MC_CONFIG["pie-chart-calculator"] = { name: "Pie Chart Calculator", fields: [{"id": "values", "label": "The totals for each group", "type": "text", "def": "12, 8, 6, 4", "hint": "One number per category, separated by commas."}], example: {"values": "12, 8, 6, 4"}, run: (function (v, H) {
      var raw = String(v.values).trim().split(/[\s,]+/).filter(function (t) { return t !== ''; });
      var nums = [], i;
      for (i = 0; i < raw.length; i++) {
        var n = Number(raw[i]);
        if (!isFinite(n)) throw new Error('"' + raw[i] + '" is not a number.');
        if (n < 0) throw new Error('A pie chart cannot show a negative amount. Check the value ' + raw[i] + '.');
        nums.push(n);
      }
      if (nums.length < 2) throw new Error('A pie chart needs at least two groups.');
      if (nums.length > 12) throw new Error('Twelve groups is plenty for one pie chart.');
      var total = 0;
      for (i = 0; i < nums.length; i++) total += nums[i];
      if (total === 0) throw new Error('The totals add up to 0, so there is nothing to draw.');
      var per = 360 / total;
      var angles = [], parts = [];
      for (i = 0; i < nums.length; i++) {
        var ang = nums[i] * per;
        angles.push(ang);
        parts.push(H.fmt(nums[i]) + ' × ' + H.fmt(per) + '° = ' + H.fmt(ang) + '°');
      }
      var sum = 0;
      for (i = 0; i < angles.length; i++) sum += angles[i];
      var list = angles.map(function (a) { return H.fmt(a) + '°'; }).join(', ');
      return {
        answer: list,
        steps: [
          'Add the groups to find the whole: ' + nums.map(H.fmt).join(' + ') + ' = ' + H.fmt(total),
          'A full circle is 360°, so one item is worth 360 ÷ ' + H.fmt(total) + ' = ' + H.fmt(per) + '°',
          'Multiply each group by that: ' + parts.join(', '),
          'So the slice angles are ' + list
        ],
        note: 'Check they add to a full turn: ' + H.fmt(sum) + '°. If your angles do not total 360°, a slice is wrong somewhere.'
      };
    }), preview: (function (v, H) { return 'Pie chart of ' + v.values; }) };
MC_CONFIG["expected-frequency-calculator"] = { name: "Expected Frequency Calculator", fields: [{"id": "f", "group": "P", "groupLabel": "The probability", "slot": "num", "label": "Ways the event can happen", "type": "number", "def": "1", "min": 0, "int": true}, {"id": "n", "group": "P", "slot": "den", "label": "Total equally likely outcomes", "type": "number", "def": "6", "gt": 0, "int": true}, {"id": "trials", "label": "Number of tries", "type": "number", "def": "120", "gt": 0, "int": true, "max": 1000000}], example: {"f": 1, "n": 6, "trials": 120}, run: (function (v, H) {
      if (v.f > v.n) throw new Error('The event cannot have more ways to happen than there are outcomes altogether.');
      var g = H.gcd(v.f, v.n) || 1;
      var sn = v.f / g, sd = v.n / g;
      var p = v.f / v.n;
      var exp = p * v.trials;
      var steps = [
        'Write the probability as a fraction: ' + H.frTok(H.fmt(v.f), H.fmt(v.n)) + (g > 1 ? ', which simplifies to ' + H.frTok(H.fmt(sn), H.fmt(sd)) : ''),
        'Expected frequency = probability × number of tries',
        'Multiply: ' + H.frTok(H.fmt(sn), H.fmt(sd)) + ' × ' + H.fmt(v.trials) + ' = ' + H.fmt(exp)
      ];
      return {
        answer: H.fmt(exp) + ' ' + H.plural(exp, 'time', 'times'),
        steps: steps,
        note: 'This is a prediction, not a promise. Rolling a dice 120 times will rarely give exactly ' + H.fmt(exp) + ' sixes, but it should land close.'
      };
    }), preview: (function (v, H) { return 'P = ' + H.frTok(v.f, v.n) + ',  tried ' + v.trials + ' times'; }) };
MC_CONFIG["capture-recapture-calculator"] = { name: "Capture Recapture Calculator", fields: [{"id": "first", "label": "Number tagged in the first catch", "type": "number", "def": "40", "gt": 0, "int": true}, {"id": "second", "label": "Size of the second catch", "type": "number", "def": "50", "gt": 0, "int": true}, {"id": "tagged", "label": "Tagged ones in the second catch", "type": "number", "def": "8", "gt": 0, "int": true}], example: {"first": 40, "second": 50, "tagged": 8}, run: (function (v, H) {
      if (v.tagged > v.second) throw new Error('You cannot find more tagged ones than the size of the second catch.');
      if (v.tagged > v.first) throw new Error('You cannot recapture more tagged ones than you tagged in the first place.');
      var est = v.first * v.second / v.tagged;
      var frac = v.tagged / v.second;
      return {
        answer: 'About ' + H.fmt(Math.round(est)),
        steps: [
          'In the second catch, ' + H.fmt(v.tagged) + ' out of ' + H.fmt(v.second) + ' were tagged, a fraction of ' + H.fmt(frac),
          'That same fraction of the whole population should be tagged, and ' + H.fmt(v.first) + ' were tagged altogether',
          'So the population is ' + H.fmt(v.first) + ' ÷ ' + H.fmt(frac) + ', which is ' + H.fmt(v.first) + ' × ' + H.fmt(v.second) + ' ÷ ' + H.fmt(v.tagged) + ' = ' + H.fmt(est),
          'Populations are whole creatures, so round it: about ' + H.fmt(Math.round(est))
        ],
        note: 'This assumes the tagged ones mixed back in evenly and nothing was born, died or moved between the two catches.'
      };
    }), preview: (function (v, H) {
      return 'Tagged ' + v.first + ', caught ' + v.second + ' again, ' + v.tagged + ' had tags';
    }) };
MC_CONFIG["profit-and-loss-calculator"] = { name: "Profit and Loss Calculator", fields: [{"id": "cost", "label": "What you paid (cost price)", "prefix": "\u00a3", "type": "number", "def": "80", "gt": 0}, {"id": "sell", "label": "What you sold it for", "prefix": "\u00a3", "type": "number", "def": "100", "min": 0}], example: {"cost": 80, "sell": 100}, run: (function (v, H) {
      var diff = v.sell - v.cost;
      if (diff === 0) {
        return {
          answer: 'You broke even',
          steps: [
            'Find the difference: ' + H.money(v.sell) + ' − ' + H.money(v.cost) + ' = ' + H.money(0),
            'Selling for exactly what you paid is neither a profit nor a loss, so the percentage is 0'
          ]
        };
      }
      var word = diff > 0 ? 'profit' : 'loss';
      var pct = Math.abs(diff) / v.cost * 100;
      return {
        answer: H.money(Math.abs(diff)) + ' ' + word + ', which is ' + H.fmt(pct) + '%',
        steps: [
          'Find the difference: ' + H.money(v.sell) + ' − ' + H.money(v.cost) + ' = ' + H.money(diff) + ', so it is a ' + word,
          'Divide by what you PAID, not what you sold it for: ' + H.money(Math.abs(diff)) + ' ÷ ' + H.money(v.cost) + ' = ' + H.fmt(Math.abs(diff) / v.cost),
          'Multiply by 100: ' + H.fmt(Math.abs(diff) / v.cost) + ' × 100 = ' + H.fmt(pct) + '%, a ' + H.fmt(pct) + '% ' + word
        ],
        note: 'Percentage profit and loss always compare with the cost price, because that is the money you had at risk.'
      };
    }), preview: (function (v, H) { return 'Bought for £' + v.cost + ', sold for £' + v.sell; }) };
MC_CONFIG["wage-calculator"] = { name: "Wage Calculator", fields: [{"id": "rate", "label": "The pay amount", "prefix": "\u00a3", "type": "number", "def": "12.50", "gt": 0}, {"id": "per", "label": "That amount is per", "type": "select", "def": "hour", "options": [["hour", "Hour"], ["day", "Day"], ["week", "Week"], ["month", "Month"], ["year", "Year"]]}, {"id": "hours", "label": "Hours worked per day", "type": "number", "def": "8", "gt": 0, "max": 24}, {"id": "days", "label": "Days worked per week", "type": "number", "def": "5", "gt": 0, "max": 7}], example: {"rate": 12.5, "per": "hour", "hours": 8, "days": 5}, run: (function (v, H) {
      var hoursWeek = v.hours * v.days;
      var steps = ['Working ' + H.fmt(v.hours) + ' hours a day for ' + H.fmt(v.days) + ' days is ' + H.fmt(hoursWeek) + ' hours a week'];
      var hourly;
      if (v.per === 'hour') { hourly = v.rate; }
      else if (v.per === 'day') { hourly = v.rate / v.hours; steps.push('A daily rate spread over ' + H.fmt(v.hours) + ' hours gives ' + H.money(v.rate) + ' ÷ ' + H.fmt(v.hours) + ' = ' + H.money(hourly) + ' an hour'); }
      else if (v.per === 'week') { hourly = v.rate / hoursWeek; steps.push('A weekly wage spread over ' + H.fmt(hoursWeek) + ' hours gives ' + H.money(v.rate) + ' ÷ ' + H.fmt(hoursWeek) + ' = ' + H.money(hourly) + ' an hour'); }
      else if (v.per === 'month') { hourly = v.rate * 12 / 52 / hoursWeek; steps.push('A month is a twelfth of a year, so the weekly pay is ' + H.money(v.rate) + ' × 12 ÷ 52 = ' + H.money(v.rate * 12 / 52) + ', which is ' + H.money(hourly) + ' an hour'); }
      else { hourly = v.rate / 52 / hoursWeek; steps.push('A year holds 52 weeks, so the weekly pay is ' + H.money(v.rate) + ' ÷ 52 = ' + H.money(v.rate / 52) + ', which is ' + H.money(hourly) + ' an hour'); }
      var daily = hourly * v.hours;
      var weekly = daily * v.days;
      var yearly = weekly * 52;
      var monthly = yearly / 12;
      steps.push('Scale it up: a day is ' + H.money(hourly) + ' × ' + H.fmt(v.hours) + ' = ' + H.money(daily) + ', and a week is ' + H.money(daily) + ' × ' + H.fmt(v.days) + ' = ' + H.money(weekly));
      steps.push('A year is 52 weeks: ' + H.money(weekly) + ' × 52 = ' + H.money(yearly) + ', and a month is a twelfth of that, ' + H.money(monthly));
      function chip(hue, big, small) { return '<span class="mc-chip mc-chip-' + hue + '">' + big + '<small>' + small + '</small></span>'; }
      function link(t) { return '<span class="mc-link">' + t + ' →</span>'; }
      var visual = '<div class="mc-chain">'
        + chip(1, H.money(hourly), 'an hour')
        + link('× ' + H.fmt(v.hours) + ' h')
        + chip(2, H.money(daily), 'a day')
        + link('× ' + H.fmt(v.days) + ' days')
        + chip(3, H.money(weekly), 'a week')
        + link('× 52')
        + chip(4, H.money(yearly), 'a year')
        + link('÷ 12')
        + chip(2, H.money(monthly), 'a month')
        + '</div>';
      return {
        answer: H.money(hourly) + ' an hour, ' + H.money(daily) + ' a day, ' + H.money(weekly) + ' a week, ' + H.money(monthly) + ' a month, ' + H.money(yearly) + ' a year',
        steps: steps,
        visual: visual,
        note: 'These are gross figures, before tax and National Insurance come off. Take home pay is always lower.'
      };
    }), preview: (function (v, H) { return '£' + v.rate + ' per ' + v.per + ',  ' + v.hours + ' h a day,  ' + v.days + ' days a week'; }) };
MC_CONFIG["density-calculator"] = { name: "Density Calculator", fields: [{"id": "find", "label": "Find which part", "type": "select", "def": "mass", "cls": "mc-ghost", "options": [["mass", "Mass"], ["density", "Density"], ["volume", "Volume"]]}, {"id": "mass", "label": "Mass (g)", "type": "number", "def": "40", "min": 0, "showIf": {"find": ["density", "volume"]}}, {"id": "density", "label": "Density (g/cm\u00b3)", "type": "number", "def": "8", "min": 0, "showIf": {"find": ["mass", "volume"]}}, {"id": "volume", "label": "Volume (cm\u00b3)", "type": "number", "def": "5", "min": 0, "showIf": {"find": ["mass", "density"]}}], example: {"find": "mass", "mass": 40, "density": 8, "volume": 5}, run: (function (v, H) {
      var target;
      if (v.find === 'mass' || v.find === 'density' || v.find === 'volume') {
        target = v.find;
        if (target === 'density' && v.volume === 0) throw new Error('The volume cannot be 0 here, there would be nothing to divide by.');
        if (target === 'volume' && v.density === 0) throw new Error('The density cannot be 0 here, there would be nothing to divide by.');
      } else {
        /* legacy zero-target convention, kept for saved links and QA cases */
        var zeros = [];
        if (v.mass === 0) zeros.push('mass');
        if (v.density === 0) zeros.push('density');
        if (v.volume === 0) zeros.push('volume');
        if (zeros.length !== 1) throw new Error('Leave exactly one box at 0, the one you want to find, and fill in the other two.');
        target = zeros[0];
      }
      var steps = ['The triangle has mass on top, with density and volume underneath, so mass = density × volume'];
      var ans, unit;
      if (target === 'mass') {
        ans = v.density * v.volume; unit = 'g';
        steps.push('Cover mass and the two underneath multiply: ' + H.fmt(v.density) + ' × ' + H.fmt(v.volume) + ' = ' + H.fmt(ans) + ' g');
      } else if (target === 'density') {
        ans = v.mass / v.volume; unit = 'g/cm³';
        steps.push('Cover density and what is left is mass over volume: ' + H.fmt(v.mass) + ' ÷ ' + H.fmt(v.volume) + ' = ' + H.fmt(ans) + ' g/cm³');
      } else {
        ans = v.mass / v.density; unit = 'cm³';
        steps.push('Cover volume and what is left is mass over density: ' + H.fmt(v.mass) + ' ÷ ' + H.fmt(v.density) + ' = ' + H.fmt(ans) + ' cm³');
      }
      return {
        answer: H.fmt(ans) + ' ' + unit, steps: steps,
        note: 'Keep the units matching: grams with cm³ gives g/cm³, kilograms with m³ gives kg/m³. Water is about 1 g/cm³, so anything denser sinks.'
      };
    }), preview: (function (v, H) {
      var f = { mass: 1, density: 1, volume: 1 }[v.find] ? v.find : null;
      function d(k, x, n, u) { return (f === k || x === '?' || x == null || (!f && Number(x) === 0)) ? n + ' = ?' : n + ' ' + x + u; }
      return d('mass', v.mass, 'mass', ' g') + ',  ' + d('density', v.density, 'density', ' g/cm³') + ',  ' + d('volume', v.volume, 'volume', ' cm³');
    }), widget: (function (v, H) {
      var f = { mass: 1, density: 1, volume: 1 }[v.find] ? v.find : 'mass';
      function cell(key, cx, cy, word, val) {
        var isFind = f === key;
        var chip = isFind
          ? '<text x="' + cx + '" y="' + (cy + 22) + '" text-anchor="middle" class="mc-dst-q">?</text>'
          : '<text x="' + cx + '" y="' + (cy + 22) + '" text-anchor="middle" class="mc-dst-val">' + (val === '?' ? '' : val) + '</text>';
        return '<g class="mc-dst-cell' + (isFind ? ' is-find' : ' is-known') + '" data-mc-tap data-set="find:' + key + '" role="button" tabindex="0" aria-label="Find ' + word + '">'
          + '<text x="' + cx + '" y="' + cy + '" text-anchor="middle" class="mc-dst-word">' + word + '</text>' + chip + '</g>';
      }
      var tri = '<svg class="mc-dst" viewBox="0 0 320 210" aria-hidden="false">'
        + '<path d="M 160 14 L 26 196 L 294 196 Z" class="mc-dst-face"/>'
        + '<line x1="93" y1="105" x2="227" y2="105" class="mc-dst-div"/>'
        + '<line x1="160" y1="105" x2="160" y2="196" class="mc-dst-div"/>'
        + cell('mass', 160, 66, 'Mass', v.mass)
        + cell('density', 118, 140, 'Density', v.density)
        + cell('volume', 202, 140, 'Volume', v.volume)
        + '</svg>';
      var FORM = { mass: 'Mass = Density × Volume', density: 'Density = Mass ÷ Volume', volume: 'Volume = Mass ÷ Density' }[f];
      return '<div class="mc-dst-wrap">' + tri + '</div>'
        + '<p class="mc-rule-line"><span class="mc-rule-f">' + FORM + '</span>'
        + '<span class="mc-rule-why">Tap the one you want: covering it leaves the formula.</span></p>';
    }) };
MC_CONFIG["pressure-calculator"] = { name: "Pressure Calculator", fields: [{"id": "find", "label": "Find which part", "type": "select", "def": "pressure", "cls": "mc-ghost", "options": [["force", "Force"], ["pressure", "Pressure"], ["area", "Area"]]}, {"id": "force", "label": "Force (N)", "type": "number", "def": "60", "min": 0, "showIf": {"find": ["pressure", "area"]}}, {"id": "pressure", "label": "Pressure (N/m\u00b2)", "type": "number", "def": "15", "min": 0, "showIf": {"find": ["force", "area"]}}, {"id": "area", "label": "Area (m\u00b2)", "type": "number", "def": "4", "min": 0, "showIf": {"find": ["force", "pressure"]}}], example: {"find": "pressure", "force": 60, "pressure": 15, "area": 4}, run: (function (v, H) {
      var target;
      if (v.find === 'force' || v.find === 'pressure' || v.find === 'area') {
        target = v.find;
        if (target === 'pressure' && v.area === 0) throw new Error('The area cannot be 0 here, there would be nothing to divide by.');
        if (target === 'area' && v.pressure === 0) throw new Error('The pressure cannot be 0 here, there would be nothing to divide by.');
      } else {
        /* legacy zero-target convention, kept for saved links and QA cases */
        var zeros = [];
        if (v.force === 0) zeros.push('force');
        if (v.pressure === 0) zeros.push('pressure');
        if (v.area === 0) zeros.push('area');
        if (zeros.length !== 1) throw new Error('Leave exactly one box at 0, the one you want to find, and fill in the other two.');
        target = zeros[0];
      }
      var steps = ['The triangle has force on top, with pressure and area underneath, so force = pressure × area'];
      var ans, unit;
      if (target === 'force') {
        ans = v.pressure * v.area; unit = 'N';
        steps.push('Cover force and the two underneath multiply: ' + H.fmt(v.pressure) + ' × ' + H.fmt(v.area) + ' = ' + H.fmt(ans) + ' N');
      } else if (target === 'pressure') {
        ans = v.force / v.area; unit = 'N/m²';
        steps.push('Cover pressure and what is left is force over area: ' + H.fmt(v.force) + ' ÷ ' + H.fmt(v.area) + ' = ' + H.fmt(ans) + ' N/m²');
      } else {
        ans = v.force / v.pressure; unit = 'm²';
        steps.push('Cover area and what is left is force over pressure: ' + H.fmt(v.force) + ' ÷ ' + H.fmt(v.pressure) + ' = ' + H.fmt(ans) + ' m²');
      }
      return {
        answer: H.fmt(ans) + ' ' + unit, steps: steps,
        note: 'N/m² is also called the pascal. Bigger area means lower pressure, which is why a drawing pin has a sharp point and a flat head.'
      };
    }), preview: (function (v, H) {
      var f = { force: 1, pressure: 1, area: 1 }[v.find] ? v.find : null;
      function d(k, x, n, u) { return (f === k || x === '?' || x == null || (!f && Number(x) === 0)) ? n + ' = ?' : n + ' ' + x + u; }
      return d('force', v.force, 'force', ' N') + ',  ' + d('pressure', v.pressure, 'pressure', ' N/m²') + ',  ' + d('area', v.area, 'area', ' m²');
    }), widget: (function (v, H) {
      var f = { force: 1, pressure: 1, area: 1 }[v.find] ? v.find : 'pressure';
      function cell(key, cx, cy, word, val) {
        var isFind = f === key;
        var chip = isFind
          ? '<text x="' + cx + '" y="' + (cy + 22) + '" text-anchor="middle" class="mc-dst-q">?</text>'
          : '<text x="' + cx + '" y="' + (cy + 22) + '" text-anchor="middle" class="mc-dst-val">' + (val === '?' ? '' : val) + '</text>';
        return '<g class="mc-dst-cell' + (isFind ? ' is-find' : ' is-known') + '" data-mc-tap data-set="find:' + key + '" role="button" tabindex="0" aria-label="Find ' + word + '">'
          + '<text x="' + cx + '" y="' + cy + '" text-anchor="middle" class="mc-dst-word">' + word + '</text>' + chip + '</g>';
      }
      var tri = '<svg class="mc-dst" viewBox="0 0 320 210" aria-hidden="false">'
        + '<path d="M 160 14 L 26 196 L 294 196 Z" class="mc-dst-face"/>'
        + '<line x1="93" y1="105" x2="227" y2="105" class="mc-dst-div"/>'
        + '<line x1="160" y1="105" x2="160" y2="196" class="mc-dst-div"/>'
        + cell('force', 160, 66, 'Force', v.force)
        + cell('pressure', 118, 140, 'Pressure', v.pressure)
        + cell('area', 202, 140, 'Area', v.area)
        + '</svg>';
      var FORM = { force: 'Force = Pressure × Area', pressure: 'Pressure = Force ÷ Area', area: 'Area = Force ÷ Pressure' }[f];
      return '<div class="mc-dst-wrap">' + tri + '</div>'
        + '<p class="mc-rule-line"><span class="mc-rule-f">' + FORM + '</span>'
        + '<span class="mc-rule-why">Tap the one you want: covering it leaves the formula.</span></p>';
    }) };
/* SHLC maths calculators: browser engine.
   Expects window.MC_HELPERS (helpers.js) and window.MC_CONFIG (generated by
   build.py from calcs.js: name, fields, example, run per handle).
   One renderer builds every calculator's fields — no calculator writes markup.
   Dawn traps: no [hidden], no window.onX slots, .is-on classes only. */
(function () {
  'use strict';

  var root = document.getElementById('shlcMc');
  if (!root) return;
  var H = window.MC_HELPERS;
  var CFG = window.MC_CONFIG || {};

  /* ---------------- hub search ---------------- */
  var search = root.querySelector('[data-mc-search]');
  if (search) {
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-mc-card]'));
    var groups = Array.prototype.slice.call(root.querySelectorAll('[data-mc-group]'));
    var emptyMsg = root.querySelector('[data-mc-empty]');
    search.addEventListener('input', function () {
      var term = search.value.toLowerCase().trim();
      var shown = 0;
      cards.forEach(function (card) {
        var hit = (card.getAttribute('data-search') || '').indexOf(term) !== -1;
        card.classList.toggle('mc-hide', !hit);
        if (hit) shown++;
      });
      groups.forEach(function (g) {
        var any = g.querySelectorAll('[data-mc-card]:not(.mc-hide)').length > 0;
        g.classList.toggle('mc-hide', !any);
      });
      if (emptyMsg) emptyMsg.classList.toggle('is-on', shown === 0);
    });
  }

  /* ---------------- calculator ---------------- */
  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* Fractions display stacked, never with a slash: helpers emit ⟦n∕d⟧ and
     this pass converts it to markup AFTER escaping, so run() output stays
     plain text and typed input can never inject HTML. Bare digit fractions
     (4/3 in a formula, 3/8 echoed from typed input) stack too; letters
     nearby (km/h, angle/360) and decimals (0.375) keep their slash. No
     lookbehind, it would crash the whole engine on older Safari. */
  function render(s) {
    return esc(s)
      .replace(/⟦([^⟦⟧∕]*)∕([^⟦⟧]*)⟧/g,
        '<span class="mc-fr"><span>$1</span><span>$2</span></span>')
      .replace(/(^|[^\d.,])(\d+)\/(\d+)(?!\.?\d|,\d)/g, function (m, pre, n, d) {
        return pre + '<span class="mc-fr"><span>' + n + '</span><span>' + d + '</span></span>';
      });
  }

  /* Formula bars (.mc-rule-f) and working-out lines (.mc-math) sit on one line
     on a wide screen but must fit a phone. Split each into nowrap chunks so a
     line can only break after an '=', ',', ':', ';' or '.', or beside a prose
     word, never inside a term like 9 + 16 and never before an '='.
     sin/cos/tan stay glued to their angle. Elements (<b>, stacked fractions)
     move whole. Already-chunked lines are skipped: re-chunking would glue the
     old chunks into one unbreakable span. */
  function isProseTok(t) {
    return /^[A-Za-z][A-Za-z']+[,.:;]?$/.test(t) && !/^(sin|cos|tan|log|ln)$/i.test(t);
  }
  function chunkRule(f) {
    if (f.querySelector('.mc-rf-c')) return;
    var nodes = Array.prototype.slice.call(f.childNodes);
    var frag = document.createDocumentFragment();
    var chunk = null, prev = '';
    function open() {
      if (chunk) return;
      chunk = document.createElement('span');
      chunk.className = 'mc-rf-c';
      frag.appendChild(chunk);
    }
    function brk() {
      if (!chunk) return;
      frag.appendChild(document.createTextNode(' '));
      chunk = null;
    }
    nodes.forEach(function (n) {
      if (n.nodeType !== 3) { open(); chunk.appendChild(n); prev = 'x'; return; }
      n.nodeValue.split(' ').forEach(function (t, j) {
        if (j > 0) {
          /* never start a line with '=': "opposite = 4" breaks after the '=' */
          /* in a list "25×6 = 150, 35×4 = 140" keep "= 150," together so the
             line breaks at the comma, not between a sum and its result */
          var listPair = /=$/.test(prev) && /,$/.test(t);
          if (!/^=/.test(t) && !listPair && (/[=,:;.]$/.test(prev) || isProseTok(prev) || isProseTok(t))) brk();
          else { open(); chunk.appendChild(document.createTextNode(' ')); }
        }
        if (t) { open(); chunk.appendChild(document.createTextNode(t)); prev = t; }
      });
    });
    f.textContent = '';
    f.appendChild(frag);
  }
  function chunkRules(el, sel) {
    if (!el) return;
    var fs = el.querySelectorAll(sel || '.mc-rule-f');
    for (var i = 0; i < fs.length; i++) chunkRule(fs[i]);
  }

  /* Working-out layout: the explanation stays as prose, the maths gets its own
     line and never wraps mid-expression. A step splits at its first ': ' when
     what follows contains an '='; a step that is pure calculation (has '=' but
     no leading explanation) becomes a maths line on its own. */
  function stepHtml(s) {
    var i = s.indexOf(': ');
    if (i > -1 && s.indexOf('=', i) > -1) {
      return s.slice(0, i + 1) + '<span class="mc-math">' + s.slice(i + 2) + '</span>';
    }
    if (i === -1 && s.indexOf('=') > -1) {
      return '<span class="mc-math">' + s + '</span>';
    }
    return s;
  }

  /* The bare control, with the full label carried as aria-label so a compact
     visible label ("Top") never costs a screen reader the real meaning. */
  function controlHtml(f, aria) {
    var name = esc(f.id);
    /* a fixed operator symbol: shown between two units, never an input */
    if (f.type === 'static') return '<span class="mc-op-sym">' + esc(f.text) + '</span>';
    var defAttr = esc(f.def == null ? '' : f.def);
    var ariaAttr = aria ? ' aria-label="' + esc(f.label) + '"' : '';
    if (f.type === 'select') {
      return '<select id="McF-' + name + '" name="' + name + '"' + ariaAttr + '>' + f.options.map(function (o) {
        return '<option value="' + esc(o[0]) + '"' + (String(o[0]) === String(f.def) ? ' selected' : '') + '>' + esc(o[1]) + '</option>';
      }).join('') + '</select>';
    }
    if (f.type === 'text') {
      return '<input id="McF-' + name + '" name="' + name + '" type="text" value="' + defAttr + '" placeholder="' + defAttr + '" autocomplete="off"' + ariaAttr + '>';
    }
    return '<input id="McF-' + name + '" name="' + name + '" type="text" inputmode="decimal" value="' + defAttr + '" placeholder="e.g. ' + defAttr + '" autocomplete="off"' + ariaAttr + '>';
  }

  function fieldHtml(f) {
    var name = esc(f.id);
    var labelBits = esc(f.label);
    if (f.suffix) labelBits += ' <span class="mc-affix">(' + esc(f.suffix) + ')</span>';
    if (f.prefix) labelBits += ' <span class="mc-affix">(' + esc(f.prefix) + ')</span>';
    return '<div class="mc-field' + (f.cls ? ' ' + esc(f.cls) : '') + '" data-field="' + name + '"><label for="McF-' + name + '">' + labelBits + '</label>' + controlHtml(f, false) +
      (f.hint ? '<p class="mc-hint">' + esc(f.hint) + '</p>' : '') + '</div>';
  }

  /* Short visible labels inside a unit, where the caption already says which
     part of the question this is. */
  var SLOT_LABEL = { whole: 'Whole', num: 'Top', den: 'Bottom' };

  /* Inside a unit the caption already says which part of the question this
     is, so "Equation 1: number with x" only needs to read "Number with x". */
  function shortLabel(f) {
    if (SLOT_LABEL[f.slot]) return SLOT_LABEL[f.slot];
    var s = f.label, i = s.indexOf(': ');
    if (i > 0 && i < 20) s = s.slice(i + 2);
    return esc(s.charAt(0).toUpperCase() + s.slice(1));
  }

  function slotHtml(f) {
    var name = esc(f.id);
    var label = shortLabel(f);
    var tag = '<label for="McF-' + name + '">' + label + '</label>';
    var ctrl = controlHtml(f, true);
    /* the denominator's label goes UNDER its box, so the bar sits directly
       between the two numbers and the unit reads as a written fraction */
    var body = f.slot === 'den' ? ctrl + tag : tag + ctrl;
    return '<div class="mc-field mc-field--slot' + (f.slot === 'den' ? ' mc-field--den' : '') +
      (f.cls ? ' ' + esc(f.cls) : '') + '" data-field="' + name + '">' + body + '</div>';
  }

  /* A run of fields sharing a group becomes one bordered, colour-coded box.
     When the group has a top and a bottom it is drawn as a real fraction,
     numerator above the bar, so the boxes match the maths on the page. */
  function unitHtml(groupFields, hue) {
    var cap = '';
    for (var i = 0; i < groupFields.length; i++) {
      if (groupFields[i].groupLabel) { cap = esc(groupFields[i].groupLabel); break; }
    }
    var whole = null, num = null, den = null, rest = [];
    groupFields.forEach(function (f) {
      if (f.slot === 'whole') whole = f;
      else if (f.slot === 'num') num = f;
      else if (f.slot === 'den') den = f;
      else rest.push(f);
    });
    var body;
    if (num && den) {
      body = '<div class="mc-frac">' +
        (whole ? slotHtml(whole) : '') +
        '<div class="mc-frac-stack">' + slotHtml(num) +
        '<span class="mc-frac-bar" aria-hidden="true"></span>' + slotHtml(den) + '</div>' +
        rest.map(slotHtml).join('') + '</div>';
    } else {
      body = '<div class="mc-unit-row">' + groupFields.map(function (f) {
        /* sep puts the notation itself between the boxes, e.g. "× 10", so the
           layout teaches the form instead of a hint telling you how to type it */
        var lead = f.sep ? '<span class="mc-sep">' + esc(f.sep) + '</span>' : '';
        return lead + slotHtml(f);
      }).join('') + '</div>';
    }
    return '<div class="mc-unit mc-hue-' + hue + '" data-unit="' + esc(groupFields[0].group) + '">' +
      (cap ? '<span class="mc-unit-cap">' + cap + '</span>' : '') + body + '</div>';
  }

  function renderFields(cfg) {
    var fields = cfg.fields, html = '', i = 0, hues = {}, next = 1;
    while (i < fields.length) {
      var f = fields[i];
      if (f.slot === 'op') {
        html += '<div class="mc-op" data-field="' + esc(f.id) + '">' + controlHtml(f, true) + '</div>';
        i++;
      } else if (f.group) {
        var run = [], g = f.group;
        while (i < fields.length && fields[i].group === g) { run.push(fields[i]); i++; }
        if (!hues[g]) { hues[g] = next; next = next % 8 + 1; }
        html += unitHtml(run, hues[g]);
      } else {
        html += fieldHtml(f);
        i++;
      }
    }
    return html;
  }

  /* A field with showIf only exists for certain choices of a select, e.g.
     the "c" box only matters in quadratic mode. Hidden fields are skipped by
     validation too, so an irrelevant box can never block the calculator. */
  function fieldVisible(f, scope) {
    if (!f.showIf) return true;
    var ctrl = Object.keys(f.showIf)[0];
    var el = scope.querySelector('[name="' + ctrl + '"]');
    if (!el) return true;
    return f.showIf[ctrl].indexOf(el.value) !== -1;
  }

  function applyVisibility(cfg, scope) {
    for (var i = 0; i < cfg.fields.length; i++) {
      var wrap = scope.querySelector('[data-field="' + cfg.fields[i].id + '"]');
      if (wrap) wrap.classList.toggle('mc-hide', !fieldVisible(cfg.fields[i], scope));
    }
    /* a unit whose fields are all hidden must go too, or an empty coloured
       box is left floating between the ones that matter */
    var units = scope.querySelectorAll('[data-unit]');
    for (var u = 0; u < units.length; u++) {
      var live = units[u].querySelectorAll('.mc-field:not(.mc-hide)').length;
      units[u].classList.toggle('mc-hide', live === 0);
    }
  }

  function readValues(cfg, scope) {
    var values = {};
    for (var i = 0; i < cfg.fields.length; i++) {
      var f = cfg.fields[i];
      if (f.type === 'static') continue;
      if (!fieldVisible(f, scope)) continue;
      var el = scope.querySelector('[name="' + f.id + '"]');
      if (!el) continue;
      var raw = el.value;
      if (f.type === 'select' || f.type === 'text') {
        if (f.type === 'text' && !String(raw).trim() && !f.optional) {
          return { error: 'Fill in "' + f.label + '" first.' };
        }
        values[f.id] = raw;
        continue;
      }
      raw = String(raw).trim().replace(/,/g, '');
      if (raw === '') return { error: 'Enter a number for "' + f.label + '".', empty: true };
      var n = Number(raw);
      if (!isFinite(n)) return { error: '"' + f.label + '" needs to be a number, so letters and symbols will not work.' };
      if (f.int && !Number.isInteger(n)) return { error: '"' + f.label + '" must be a whole number.' };
      if (typeof f.min === 'number' && n < f.min) return { error: '"' + f.label + '" cannot be less than ' + f.min + '.' };
      if (typeof f.gt === 'number' && n <= f.gt) return { error: '"' + f.label + '" must be greater than ' + f.gt + '.' };
      if (typeof f.max === 'number' && n > f.max) return { error: '"' + f.label + '" cannot be more than ' + f.max + '.' };
      values[f.id] = n;
      if (f.keepRaw) values[f.id + 'Raw'] = raw;
    }
    return { values: values };
  }

  function activeScope() {
    var s = root.querySelector('[data-mc-page].is-on');
    return s || root;
  }

  function mount() {
    var scope = activeScope();
    var handle = scope.getAttribute('data-mc-page') || root.getAttribute('data-handle');
    var cfg = CFG[handle];
    var holder = scope.querySelector('[data-mc-fields]');
    var form = scope.querySelector('[data-mc-form]');
    if (!cfg || !holder || !form) return;

    holder.innerHTML = renderFields(cfg);
    /* server-rendered worked example: its working-out lines wrap on a phone too */
    chunkRules(root, '.mc-math');

    var errEl = scope.querySelector('[data-mc-error]');
    var resEl = scope.querySelector('[data-mc-result]');
    var ansEl = scope.querySelector('[data-mc-answer]');
    var stepsEl = scope.querySelector('[data-mc-steps]');
    var noteEl = scope.querySelector('[data-mc-note]');
    var prevEl = scope.querySelector('[data-mc-preview]');
    var widEl = scope.querySelector('[data-mc-widget]');
    var visEl = scope.querySelector('[data-mc-visual]');

    function showError(msg) {
      errEl.textContent = msg;
      errEl.classList.add('is-on');
      resEl.classList.remove('is-on');
    }

    /* every field's current value as displayable strings: selects verbatim,
       numbers as typed, or ? when empty/not a number. Feeds preview + widget. */
    function readRaw() {
      var raw = {};
      for (var i = 0; i < cfg.fields.length; i++) {
        var f = cfg.fields[i];
        var el = scope.querySelector('[name="' + f.id + '"]');
        if (!el) continue;
        var val = String(el.value).trim().replace(/,/g, '');
        if (f.type === 'select' || f.type === 'text') raw[f.id] = el.value;
        else raw[f.id] = val === '' || !isFinite(Number(val)) ? '?' : val;
      }
      return raw;
    }

    /* live "your question" line: missing numbers show as ? so it is always
       obvious what shape of question is being built */
    function updatePreview() {
      if (!prevEl || !cfg.preview) return;
      try {
        prevEl.innerHTML = render(cfg.preview(readRaw(), H));
      } catch (ex) {
        prevEl.innerHTML = '';
      }
    }

    /* Optional per-calc widget: a pure function of the raw values returning
       markup (usually SVG) drawn above the fields. Elements carrying
       data-mc-tap + data-set="field:value,field:value" write those values
       back into the form when tapped, so the widget IS the control and the
       hidden fields stay the single source of truth for run(), QA and fuzz.
       Stateless by design: every transition is computed at render time. */
    function updateWidget() {
      if (!widEl || !cfg.widget) return;
      try {
        var wHtml = cfg.widget(readRaw(), H);
        /* a widget may return '' to sit out (e.g. a bar model with nothing
           drawable): the container hides so no empty margin is left behind */
        widEl.innerHTML = wHtml || '';
        chunkRules(widEl);
        widEl.classList.toggle('is-on', !!wHtml);
      } catch (ex) {
        widEl.innerHTML = '';
        widEl.classList.remove('is-on');
      }
    }

    /* Optional dynamic labels: cfg.labels(raw) returns {fieldId: text} so a
       generic box ("Its length") can rename itself to the side just picked
       on the widget ("Hypotenuse length"). Static labels stay in calcs.js
       for the QA gates and as the no-widget fallback. */
    function applyLabels() {
      if (!cfg.labels) return;
      var map;
      try { map = cfg.labels(readRaw(), H); } catch (ex) { return; }
      for (var id in map) {
        /* "cap:b" renames unit b's caption, e.g. "End time" to "Duration to add" */
        if (id.indexOf('cap:') === 0) {
          var capEl = scope.querySelector('[data-unit="' + id.slice(4) + '"] .mc-unit-cap');
          if (capEl) capEl.textContent = map[id];
          continue;
        }
        var lab = scope.querySelector('[data-field="' + id + '"] label');
        if (lab) lab.textContent = map[id];
      }
    }

    /* auto = true when fired from typing: incomplete fields stay quiet, the
       result simply waits; real mistakes (letters, zero denominators) show */
    function calculate(auto) {
      errEl.classList.remove('is-on');
      var got = readValues(cfg, scope);
      if (got.error) {
        if (auto && got.empty) { resEl.classList.remove('is-on'); return; }
        showError(got.error);
        return;
      }
      var out;
      try {
        out = cfg.run(got.values, H);
      } catch (ex) {
        showError((ex && ex.message) || 'Check the values and try again.');
        return;
      }
      if (!out || out.answer == null || !out.steps || !out.steps.length) {
        showError('Check the values and try again.');
        return;
      }
      ansEl.innerHTML = render(out.answer);
      /* optional per-answer visual (e.g. the time line): drawn between the
         answer and the steps, cleared whenever a run does not send one */
      if (visEl) {
        if (out.visual) { visEl.innerHTML = out.visual; chunkRules(visEl); visEl.classList.add('is-on'); }
        else { visEl.innerHTML = ''; visEl.classList.remove('is-on'); }
      }
      stepsEl.innerHTML = out.steps.map(function (s) { return '<li>' + stepHtml(render(s)) + '</li>'; }).join('');
      chunkRules(stepsEl, '.mc-math');
      if (noteEl) {
        if (out.note) { noteEl.innerHTML = render(out.note); noteEl.classList.add('is-on'); }
        else { noteEl.classList.remove('is-on'); noteEl.innerHTML = ''; }
      }
      resEl.classList.add('is-on');
    }

    var liveTimer = null;
    function onLive() {
      applyVisibility(cfg, scope);
      applyLabels();
      updatePreview();
      updateWidget();
      window.clearTimeout(liveTimer);
      liveTimer = window.setTimeout(function () { calculate(true); }, 160);
    }

    function resetForm() {
      holder.innerHTML = renderFields(cfg);
      applyVisibility(cfg, scope);
      applyLabels();
      errEl.classList.remove('is-on');
      updatePreview();
      updateWidget();
      calculate(true);
    }

    /* one tap on the widget writes its data-set pairs into the form */
    function widgetTap(t) {
      var spec = t.getAttribute('data-set') || '';
      var pairs = spec.split(',');
      for (var i = 0; i < pairs.length; i++) {
        var kv = pairs[i].split(':');
        if (kv.length !== 2) continue;
        var el = scope.querySelector('[name="' + kv[0] + '"]');
        if (el) el.value = kv[1];
      }
      if (form.__mcLive) form.__mcLive();
    }

    if (widEl && widEl.getAttribute('data-mc-bound') !== '1') {
      widEl.setAttribute('data-mc-bound', '1');
      widEl.addEventListener('click', function (e) {
        var t = e.target && e.target.closest ? e.target.closest('[data-mc-tap]') : null;
        if (t && widEl.__mcTap) widEl.__mcTap(t);
      });
      widEl.addEventListener('keydown', function (e) {
        if (e.key !== 'Enter' && e.key !== ' ') return;
        var t = e.target && e.target.closest ? e.target.closest('[data-mc-tap]') : null;
        if (t && widEl.__mcTap) { e.preventDefault(); widEl.__mcTap(t); }
      });
    }
    if (widEl) widEl.__mcTap = widgetTap;

    if (form.getAttribute('data-mc-bound') !== '1') {
      form.setAttribute('data-mc-bound', '1');
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (form.__mcCalculate) form.__mcCalculate();
      });
      form.addEventListener('reset', function () {
        window.setTimeout(function () { if (form.__mcReset) form.__mcReset(); }, 0);
      });
      form.addEventListener('input', function () { if (form.__mcLive) form.__mcLive(); });
      form.addEventListener('change', function () { if (form.__mcLive) form.__mcLive(); });
      /* tapping a box selects the example inside it, so typing replaces it,
         no manual deleting. The one-shot mouseup guard stops the browser
         undoing the selection a moment later. */
      form.addEventListener('focusin', function (e) {
        var t = e.target;
        if (!t || t.tagName !== 'INPUT') return;
        window.setTimeout(function () { try { t.select(); } catch (ex) {} }, 0);
        t.addEventListener('mouseup', function guard(ev) {
          ev.preventDefault();
          t.removeEventListener('mouseup', guard);
        });
      });
    }
    /* keep the listeners pointed at the newest closures after a remount */
    form.__mcCalculate = calculate;
    form.__mcReset = resetForm;
    form.__mcLive = onLive;

    /* the page opens already answered: the example is filled in, the question
       line and the full method are visible before anyone touches a key */
    applyVisibility(cfg, scope);
    applyLabels();
    updatePreview();
    updateWidget();
    calculate(true);
  }

  mount();

  if (window.__MC_HARNESS) {
    window.__mc = {
      config: CFG,
      helpers: H,
      mount: function (handle) {
        var pages = root.querySelectorAll('[data-mc-page]');
        for (var i = 0; i < pages.length; i++) {
          pages[i].classList.toggle('is-on', pages[i].getAttribute('data-mc-page') === handle);
        }
        root.setAttribute('data-handle', handle);
        mount();
      },
      calculate: function () {
        var form = activeScope().querySelector('[data-mc-form]');
        if (form && form.__mcCalculate) form.__mcCalculate();
      }
    };
  }
})();
